import Vue from 'vue';
import validationMessages from './lang/validation';
import VeeValidate, { Validator } from 'vee-validate';
import UnitSelector from './components/UnitSelector.vue';
import ChangePasswordForm from './components/forms/ChangePasswordForm.vue';
import RegisterForm from './components/forms/RegisterForm.vue';
import FgTable from './components/FgTable.vue';
import FgModal from './components/FgModal.vue';
import FormError from './components/FormError.vue';
import AttendeeList from './components/AttendeeList.vue';
import QrReader from './components/QrReader.vue';
import QrCode from './components/QrCode.vue'
import ActivityCard from './components/ActivityCard.vue'
import ActivityWidget from './components/ActivityWidget'
import ActivityCalendar from './components/ActivityCalendar.vue';
import MultipleDateSelection from './components/MultipleDateSelection.vue';

Vue.use(VeeValidate, {
    locale: 'fi',
    classes: true,
    validity: true,
    classNames: {
        valid: "is-valid",
        invalid: "is-invalid"
    }
});
Validator.localize(validationMessages);

const app = new Vue({
    el: '#app',
    components: {
        ChangePasswordForm,
        RegisterForm,
        UnitSelector,
        FgTable,
        FgModal,
        FormError,
        AttendeeList,
        QrCode,
        QrReader,
        ActivityCard,
        ActivityWidget,
        ActivityCalendar,
        MultipleDateSelection,
    },
    data: {
        garrison_id: '',
        unit_id: '',
        year_id: '',
        garrisons: {},
        units: {},
        sports: {},
        item: {},
        currentPoints: {},
        activityType: {},
        show: {
            type: Boolean,
            default: true
        }
    },
    created() {
        if (typeof Liikkuri !== 'undefined') {
            this.garrisons = Liikkuri.garrisons;
            this.garrison_id = Liikkuri.garrison_id;
            this.units = Liikkuri.units;
            this.unit_id = Liikkuri.unit_id;
            this.sports = Liikkuri.sports;
            this.item = Liikkuri.item;
            this.currentPoints = Liikkuri.currentPoints;
        }
    }
});
